/**
 * #147 · Herramientas del back-office.
 *
 * Carpeta propia por lo mismo que `hq-clients`: el descubrimiento de
 * `AppRoutes` toma UN `moduleRoutes` por carpeta y las pantallas del panel
 * comparten `routes/hq/`.
 */
import { ToolingPage } from '../hq/ToolingPage';
import type { ModuleRoutes } from '../module';

export const moduleRoutes: ModuleRoutes = {
  moduleId: 'tooling',
  minimumRole: 'admin',
  routes: [{ path: '', element: <ToolingPage /> }],
};
